import TemplateView from '../../../../TemplateView'
import CopyAssignmentsFromButton from '../../CopyAssignmentsFromButton'
import CopyUserSelector from '../../CopyUserSelector'
import messageResource from '../../../../messageResource'
import CounterWithProgressBar from '../../../../components/counterCPT/CounterWithProgressBar'
import {HierarchyLevels} from 'constants'
import {bindActionCreators} from 'redux'
import {connect} from '../../../../redux/utils'
import UserWithAccessRights from '../../../../store/UserWithAccessRights'
import {isTZGEnabled, isUGREnabled, isWASEnabled} from '../../../../features/selectors'
import {customerNameLower, projectNameLower, taskNameLower} from '../../../../util/pluralizeUtils'
import {getCopyUserCounters, getCopyUserFrom, getCopyUserId, getPanelUserFirstName, getSelectorsUsers, isUserHasSelectedScope} from '../selectors'
import {cancelCopy, copyAssignments, loadUserCounters} from '../actions'
import {getSortedTimeZoneGroupsList, getSortedUserGroupsList} from '../../workAssignmentsTab/selectors'

class CopyContent extends TemplateView {
    constructor({
        onCancel = () => {},
        onSelectUser = (userId) => {},
        onCopy = () => {},
        refreshScrollCb = () => {},
    } = {}) {
        super()

        this.params = {
            onCancel,
            onSelectUser,
            onCopy,
            refreshScrollCb,
        }

        this.state = {
            userId: null,
            userFrom: null,
            userTo: null,
            viewer: null,
            userHasSelectedScope: false,

            counters: {
                tasks: 0,
                projects: 0,
                customers: 0,
            },

            users: [],
            userGroups: [],
            timeZoneGroups: [],

            ugrEnabled: true,
            tzgEnabled: true,
            wasEnabled: false,
            ttaEnabled: false,
        }

        this.onAnyStatePropertyChanged(['userFrom', 'userHasSelectedScope'], (state) => {
            this.copyAssignmentsButton.setState({
                selectedUser: state.userFrom,
            })
            this._updateCommentNote()
        })

        this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups', 'ugrEnabled', 'tzgEnabled'], () => {
            const usersWithAccessRights = this.state.users.map(userFrom => UserWithAccessRights.fromRPC(userFrom))

            this.copyUserSelector.setState({
                users: usersWithAccessRights,
                ugrEnabled: this.state.ugrEnabled,
                userGroups: Object.values(this.state.userGroups),
                tzgEnabled: this.state.tzgEnabled,
                timeZoneGroups: Object.values(this.state.timeZoneGroups),
            })
        })

        this.onAnyStatePropertyChanged(['userId', 'counters'], (state) => {
            const userId = state.userId
            const counters = state.counters
            const isCopyEnabled = userId !== null

            this.customerCounter.setState({
                curValue: counters.customers,
                maxValue: counters.customers,
                title: customerNameLower(counters.customers),
                active: counters.customers > 0,
            })

            this.projectCounter.setState({
                curValue: counters.projects,
                maxValue: counters.projects,
                title: projectNameLower(counters.projects),
                active: counters.projects > 0,
            })

            this.taskCounter.setState({
                curValue: counters.tasks,
                maxValue: counters.tasks,
                title: taskNameLower(counters.tasks),
                active: counters.tasks > 0,
            })

            this.find('.counters').toggleClass('invisible', !isCopyEnabled)
            this.$copyButton.toggleClass('disabled', !isCopyEnabled)
        })
    }

    templateHtml() {
        return '<div class="copyContent">' +
               '  <div class="title"><%-title%></div>' +
               '  <div class="userSelector"/>' +
               '  <div class="counters">' +
               '    <div class="title"><%-counterTitle%></div>' +
               '    <div class="customers"></div>' +
               '    <div class="projects"></div>' +
               '    <div class="tasks"></div>' +
               '  </div>' +
               '  <div class="commentNote">' +
               '    <div class="part1"/>' +
               '    <div class="part2"/>' +
               '  </div>' +
               '  <div class="buttonsSection">' +
               '    <div class="copyButton"><%-copy%></div>' +
               '    <div class="cancelButton"><%-cancel%></div>' +
               '  </div>' +
               '</div>'
    }

    templateModel() {
        return {
            title: messageResource.getMessage('management_assignment.panel.copy.title'),
            counterTitle: messageResource.getMessage('work_assignments.panel.copy.counter_title'),
            copy: messageResource.getMessage('common.copy'),
            cancel: messageResource.getMessage('common.cancel'),
        }
    }

    afterRender() {
        this.$userSelector = this.find('.userSelector')
        this.$countersSection = this.find('.counters')
        this.$copyButton = this.find('.copyButton')
        this.$cancelButton = this.find('.cancelButton')

        this.$cancelButton.click(() => {
            this.params.onCancel()
        })

        this.$copyButton.click(() => {
            if (this._copyEnabled()) {
                this.params.onCopy()
            }
        })

        this.copyUserSelector = new CopyUserSelector({
            title: messageResource.getMessage("user.add.js.copy_setting.selector.label"),
            selectionCallback: (user) => {
                this.params.onSelectUser(user.id)
                this.copyUserSelector.hide()
            },
            onHideCb: () => {
                this.$el.removeClass('withUserSelector')
                this.params.refreshScrollCb()
            },
            showPermissionIcons: false,
            renderTo: this.getEl(),
        }).init()

        this.$customerCounter = this.find('.counters .customers')
        this.customerCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
            pale: true,
        }).init(this.$customerCounter)

        this.$projectCounter = this.find('.counters .projects')
        this.projectCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.PROJECT,
            pale: true,
        }).init(this.$projectCounter)

        this.$taskCounter = this.find('.counters .tasks')
        this.taskCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.TASK,
            pale: true,
        }).init(this.$taskCounter)

        this.copyAssignmentsButton = new CopyAssignmentsFromButton().init(this.$userSelector)
        this.copyAssignmentsButton.bindClick(() => {
            this.copyUserSelector.showAt(this.copyAssignmentsButton.$el, "t-b")
            this.$el.toggleClass('withUserSelector', true)
            this.params.refreshScrollCb()
        })

        this.$commentNote = this.find('.commentNote')
        this.$commentNote1 = this.$commentNote.find('.part1')
        this.$commentNote2 = this.$commentNote.find('.part2')
    }

    _copyEnabled() {
        return this.state.userId !== null
    }

    _updateCommentNote() {
        this.$commentNote.toggleClass('invisible', !this.state.userFrom)
        if(this.state.userTo) {
            this.$commentNote1.text(messageResource.getMessage('management_assignment.panel.copy.note_part1', [this.state.userTo]))

            this.$commentNote2.toggleClass('invisible', !this.state.wasEnabled || !this.state.userHasSelectedScope)

            if (this.state.wasEnabled && this.state.userHasSelectedScope)
                this.$commentNote2.html(messageResource.getMessageWithEscapedArgs('management_assignment.panel.copy.note_part2', [this.state.userTo]))
        }
    }
}

export default connect(
    state => ({
        userId: getCopyUserId(state),
        userFrom: getCopyUserFrom(state),
        userTo: getPanelUserFirstName(state),

        counters: getCopyUserCounters(state),
        userHasSelectedScope: isUserHasSelectedScope(state),

        users: getSelectorsUsers(state),
        ugrEnabled: isUGREnabled(state),
        userGroups: getSortedUserGroupsList(state),
        tzgEnabled: isTZGEnabled(state),
        timeZoneGroups: getSortedTimeZoneGroupsList(state),

        wasEnabled: isWASEnabled(state),
    }),
    dispatch => ({
        onSelectUser: bindActionCreators(loadUserCounters, dispatch),
        onCopy: bindActionCreators(copyAssignments, dispatch),
        onCancel: bindActionCreators(cancelCopy, dispatch),
    })
)(CopyContent)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/editManagementAssignmentsPanel/components/CopyContent.js